module.exports = __webpack_public_path__ + "media/media/about/comm-3-ccf8d9397feb0c6bf20e94327842c55b.png";